function highlightWordInSelector(selector, wordToHighlight, color) {
    var elements = document.querySelectorAll(selector);

    elements.forEach(function (element) {
        var regex = new RegExp(wordToHighlight, "gi");

        element.innerHTML = element.innerHTML.replace(
            regex,
            function (matched) {
                return (
                    '<span style="color:' +
                    color +
                    '; font-weight: bold;">' +
                    matched +
                    "</span>"
                );
            }
        );
    });
}

document.addEventListener("DOMContentLoaded", function () {
    highlightWordInSelector(".custom-heading", "addicting", "#20abee");
    highlightWordInSelector(
        ".course-content-container p",
        "Bassline Blueprint",
        "#20abee"
    );
    highlightWordInSelector(".course-content-container p", "Fisher", "#20abee");
    highlightWordInSelector(
        ".course-content-container p",
        "Daft Punk",
        "#20abee"
    );
    highlightWordInSelector(".highlight p", "100%", "#00CB00");
});
